import { useTranslation } from "@repo/core";

const MissingDrawdown = ({ className = "" }: { className?: string }) => {
  const { tDrawdowns } = useTranslation();

  return (
    <div
      className={`bg-white rounded-lg shadow-sm border border-gray-200 p-6 ${className}`}
    >
      <h2 className="text-lg font-semibold text-gray-900 mb-4">
        {tDrawdowns("title")}
      </h2>

      <hr className="border-gray-200 mb-6" />

      <div className="text-center py-12">
        <div className="text-gray-500">
          <div className="text-6xl mb-4">📉</div>
          <h3 className="text-lg font-medium text-gray-900 mb-2">
            {tDrawdowns("notAvailable")}
          </h3>
          <p className="text-gray-600">{tDrawdowns("unableToLoad")}</p>
        </div>
      </div>
    </div>
  );
};

export default MissingDrawdown;
